import Query from '../../components/Report';

export const discoverQuery = (domains_urls) =>
    new Query('domains-overview-discover', { domains_urls: `(${domains_urls})` });

export const searchQuery = (domains_urls) =>
    new Query('domains-overview-search', { domains_urls: `(${domains_urls})` });
